import { FC, useMemo } from 'react';
import { GameData, GAMESOURCE } from 'react-easyrocket';
import dropsAndWinsBadge from 'src/assets/images/dropsAndWinsBadge.webp';
import { categoryBadgeGame } from 'src/constants';
import { useGameHandleClick } from 'src/hooks/useGameHandleClick';
import { twMerge } from 'tailwind-merge';
import { GameCardBanner, GameCardBannerType } from './components/GameCardBanner';
import { GameControls } from './components/GameControls';
import { GameGradient } from './components/GameGradient';
import { GameImage } from './components/GameImage';

interface GameProps {
  game: GameData;
  className?: string;
  navigationState?: string;
  onClick?: () => void;
}

const DROPS_AND_WINS_CATEGORY = 587;

export const GameCard: FC<GameProps> = ({ game, onClick, className }) => {
  const { handleNavigateToGame, toggleFavorite, isFavorite, handleNavigateToDemoGame } =
    useGameHandleClick({
      game: game,
      onClick
    });

  const { image, isWagering, categories, imagine } = game;

  const isGameGradient = Boolean(imagine?.gradient_color);

  const handlePlay = () => {
    handleNavigateToGame();
  };

  const handlePlayDemo = () => {
    handleNavigateToDemoGame();
  };

  const isDropsAndWins = game.categories?.some((category) => {
    return category.id === DROPS_AND_WINS_CATEGORY;
  });

  const badgeGame = useMemo(() => {
    if (categories) {
      for (const badge of categories) {
        return categoryBadgeGame[badge.id as keyof typeof categoryBadgeGame];
      }
    }
    return false;
  }, [categories]);

  if (!image) {
    return null;
  }

  return (
    <div
      className={twMerge(
        'card-game cursor-pointer relative group overflow-hidden rounded-md shadow-xl',
        className
      )}>
      {isGameGradient && <GameGradient game={game} />}
      <GameImage game={game} />
      {isDropsAndWins && (
        <div className="absolute left-0 top-0 z-[3] w-full pr-[10%]">
          <img alt="drops-wins" src={dropsAndWinsBadge} className="h-auto w-[80px] rounded-tl-md" />
        </div>
      )}
      <div className="flex absolute z-[3] justify-start items-center flex-wrap top-2 left-2 gap-2">
        {game.source === GAMESOURCE.CasinoLive && !isDropsAndWins && (
          <GameCardBanner type={GameCardBannerType.LIVE} />
        )}
        {badgeGame && !location.pathname.includes('account/jackpots') && !isDropsAndWins && (
          <GameCardBanner type={badgeGame.type} />
        )}
        {isWagering && !isDropsAndWins && <GameCardBanner type={GameCardBannerType.BONUS} />}
      </div>

      <GameControls
        handleNavigateToDemoGame={handlePlayDemo}
        handlePlay={handlePlay}
        hasDemo={game.hasDemo}
        handleFavoriteClick={toggleFavorite}
        isFavorite={isFavorite}
      />
    </div>
  );
};
